import { render, staticRenderFns } from "./TravelCategorySub.vue?vue&type=template&id=3ef068cb&"
import script from "./TravelCategorySub.vue?vue&type=script&lang=js&"
export * from "./TravelCategorySub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports